<template>
  <main-template ref="main_template" class="favorite">
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          Избранные товары
          <span v-if="productsData.list != undefined" class="title_span">{{productsData.products_count}} товаров</span>
        </h1>
        <div class="clear" v-if="productsData.list != undefined">
          <basket-button></basket-button>
          <span @click="removeAllFavorite()">Очистить избранное</span>
        </div>
      </div>



      <div class="page_content">
        <table-product
            v-if="productsData.list != undefined"
            :products-data="productsData"
            @basket_changed="basket_changed_handler()"
        ></table-product>
      </div>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BasketButton from "@/components/share/BasketButton";
import axios from "axios";
import TableProduct from "@/components/catalog/section/TableProduct";

export default {
  name: 'FavoriteView',
  components: {
    TableProduct,
    BasketButton,
    MainTemplate,
  },
  data() {
    return{
      productsData : []
    }
  },
  mounted() {
    this.loadData();
  },
  methods : {
    removeAllFavorite : async function() {
      await axios.get(window.api_url + "favorite/remove_all");
      this.productsData.list = undefined;
    },
    loadData : async function() {
      let page = this.$route.query.page;
      let res = await axios.get(window.api_url + "favorite/list?page="+page);
      this.productsData = res.data.data;
    },
    basket_changed_handler : function() {
      this.$refs.main_template.refreshHeader();
    }
  },
  watch: {
    '$route.query'() {
      let page = this.$route.query.page;
      console.log("page: " + page);
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page_content {

}

.clear {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.clear span {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
}

.empty_message {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .page_top {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
  }
}
</style>

<style>
.favorite .table-product .count span {
  visibility: hidden;
}
</style>
